import { Injectable } from '@angular/core';
import { BaseService } from 'src/services/core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Restaurant, Address } from 'src/services/classes/models/restaurant';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('');

const routes = {
  restaurantDetails: 'restaurants/get-branch',
  restaurantTables: 'restaurants/all-tables',
  restaurantCharges: 'restaurants/charges',
  callWaiter: 'waiters/call-waiter',
  notifyWaiter: 'waiters/notify-waiter',
  moveTable: 'waiters/request-move-table',
};

@Injectable({
  providedIn: 'root',
})
export class RestaurantService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  getRestaurantDetails(restaurantId: number): Observable<any> {
    return this.sendGet(
      this.baseUrl(`${routes.restaurantDetails}/${restaurantId}`)
    );
  }

  getOpenTablesInRestaurant(restaurantId: number): Observable<any> {
    return this.sendGet(
      this.baseUrl(`${routes.restaurantTables}/${restaurantId}`)
    );
  }

  getCharges(branchId: number, orderType: string): Observable<any> {
    return this.sendGet(
      this.baseUrl(`${routes.restaurantCharges}/${branchId}?orderType=${orderType}`)
    );
  }

  fetchRestaurantInformation(): Restaurant | null {
    const encryptedRestaurantInformation =
      localStorage.getItem('restaurant') || null;
    const decryptedInformation =
      encryptedRestaurantInformation !== null
        ? atob(encryptedRestaurantInformation)
        : null;
    const info =
      decryptedInformation !== null
        ? decryptedInformation.replace('1234', '')
        : null;
    const restaurantInformation = info !== null ? JSON.parse(info) : null;
    return restaurantInformation || null;
  }

  createAddress(address: Address): String {
    if (address !== null) {
      const addressLine = address?.line;
      const addressCity = address?.city;
      const addressState = address?.state;
      const addressCountry = address?.country;
      // const fullAddress = `(${addressLine}) ${addressCity}, ${addressState}, ${addressCountry}`;
      const fullAddress =
        (addressLine ? `${addressLine}, ` : '') +
        (addressCity ? `${addressCity}, ` : '') +
        (addressState ? `${addressState}, ` : '') +
        (addressCountry ? `${addressCountry}` : '');

      return fullAddress;
    }
    return '';
  }

  callWaiter(table: number): Observable<any> {
    return this.sendGet(this.baseUrl(`${routes.callWaiter}/${table}`));
  }

  notifyWaiter(table: number, mode = 'pos'): Observable<any> {
    return this.sendGet(
      this.baseUrl(`${routes.notifyWaiter}/${table}?mode=${mode}`)
    );
  }

  notifyWaiterWithPayload(table: number, payload: any): Observable<any> {
    return this.sendPost(this.baseUrl(`${routes.notifyWaiter}/${table}`), payload);
  }

  requestMoveTable(table: number): Observable<any> {
    return this.sendGet(this.baseUrl(`${routes.moveTable}/${table}`));
  }

  notifyWaiterForMoveTable(table: number, payload: any = {}): Observable<any> {
    return this.sendPost(this.baseUrl(`${routes.notifyWaiter}/${table}`), payload);
  }
}
